import { Mail, Phone } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";
import { SocialButtons } from "@/components/SocialButtons";

export const Footer = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  return (
    <footer className="border-t border-border bg-card" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-10 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-12">
        <div>
          <p className="text-lg font-extrabold">{settings?.org_name}</p>
          <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} · {t("footer_rights")}</p>
        </div>
        <div className="flex flex-col gap-2 text-sm text-muted-foreground sm:flex-row sm:gap-6">
          {(settings?.contact_email || settings?.contact_phone) && <span className="font-semibold text-foreground">{t("footer_contact")}</span>}
          {settings?.contact_email && <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-2 hover:text-primary" data-testid="footer-email"><Mail className="h-4 w-4" />{settings.contact_email}</a>}
          {settings?.contact_phone && <span className="flex items-center gap-2" data-testid="footer-phone"><Phone className="h-4 w-4" />{settings.contact_phone}</span>}
        </div>
        <SocialButtons testPrefix="footer" />
      </div>
    </footer>
  );
};
